const { useEffect, useState } = require('react');

exports.useClassMemberLoading = function useClassMemberLoading({ classId, hasClassmates, loadClassmates }) {

    const [requestState, setRequestState] = useState({
        classId,
        loading: true
    });

    useEffect(() => {

        let isCurrent = true;

        setRequestState({
            classId,
            loading: true
        });

        Promise.resolve(loadClassmates(classId))
            .catch((err) => {

                console.error('[class detail] failed to resolve initial classmates', {
                    classId,
                    error: err
                });
            })
            .finally(() => {

                if (isCurrent) {
                    setRequestState({
                        classId,
                        loading: false
                    });
                }
            });

        return () => {

            isCurrent = false;
        };
    }, [classId, loadClassmates]);

    const loadingCurrentClass = requestState.classId !== classId || requestState.loading;

    return loadingCurrentClass && !hasClassmates;
};
